// Module
var code = "<div v-if=\"hasLayer()\" class=\"mapboxgl-ctrl mapboxgl-ctrl-group layer-editor-component\">\n    <h1>{{ manager.activeDrawLayer.title }}</h1>\n    <v-layout>\n        <img v-for=\"(value,key,index) in types\" :key=\"key\" :src=\"value.icon\" @click=\"addIcon(key)\"\n            class=\"layer-editor-type-image\" />\n    </v-layout>\n</div>";
// Exports
module.exports = code;